class CustomAccordionOnePerView extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const accordionItems = this.querySelectorAll('.accordion-item');
        const handleAccordionClick = (event) => {
            const accordionContent = event.currentTarget.nextElementSibling;
            const contentHeight = accordionContent.scrollHeight;

            if(event.currentTarget.parentNode.classList.contains('open')){
                event.currentTarget.parentNode.classList.remove('open')
                accordionContent.style.maxHeight = null;
            } else {
                event.currentTarget.parentNode.classList.add('open')
                accordionContent.style.maxHeight = `${contentHeight + 44}px`;
                accordionItems.forEach((item) => {
                    if(item !== event.currentTarget.parentNode){
                        item.classList.remove('open');
                        item.querySelector('.accordion-content').style.maxHeight = null;
                    }
                });
            }
        };

        if (accordionItems) {
            accordionItems.forEach((item) => {
                const accordionHeader = item.querySelector('.accordion-header');
                accordionHeader.addEventListener('click', handleAccordionClick);
                if(accordionHeader.parentNode.classList.contains('open')){
                    const accordionContent = accordionHeader.nextElementSibling;
                    const contentHeight = accordionContent.scrollHeight;
                    accordionContent.style.maxHeight = `${contentHeight + 44}px`;
                }
            });
        }
    }

}

customElements.define('custom-accordion-one-per-view', CustomAccordionOnePerView);